<div id="tableContainer-1">
  <form [formGroup]="selectForm" style="display: block">
    <table style="display: block" >
      <tr>
          <th> Please select one of the following options:</th>
      <tr>
        <div>

          <table id="tableContainer-2">

            <div class="requesttype-radio-group">
                <tr *ngFor="let requesttype of requesttypes; index as i">
                  <td *ngIf="requesttype.id == 'D'">
                    <input type="radio" formControlName="requestType" [value]="requesttype.id" checked/>
                    {{requesttype.text}}
                    <ng-container *ngIf="currentDate.asOfDate; else skeleton">
                      {{currentDate.asOfDate}}
                    </ng-container>
                  </td>
                    <td *ngIf="requesttype.id == 'M'">
                      <input type="radio" formControlName="requestType" [value]="requesttype.id">
                      {{requesttype.text}} 
                      <ng-container *ngIf="monthEndDate.asOfDate; else skeleton">
                        {{monthEndDate.asOfDate}}
                      </ng-container>
                    </td>
                    <td *ngIf="requesttype.id == 'H'">
                      <input type="radio" formControlName="requestType" [value]="requesttype.id">
                      {{requesttype.text}} {{historyDate.asOfDate}}
                    </td>
                </tr>
            </div>
            <ng-template #skeleton>
              <kendo-skeleton shape="text" width="30%" style="display: inline-block; position: relative;"></kendo-skeleton>
            </ng-template>

            <tr>
            </tr>
                  <div *ngIf='dateRangeChk' class="datetype-radio-group">
                        <tr *ngFor="let daterequesttype of daterequesttypes; index as i;">
                          <td *ngIf="daterequesttype.id == 'I'">
                            <input type="radio" formControlName="invoiceType" [value]="daterequesttype.id">
                            {{daterequesttype.text}}
                          </td>
                          <td *ngIf="daterequesttype.id == 'N'">
                            <input type="radio" formControlName="invoiceType" [value]="daterequesttype.id">
                            {{daterequesttype.text}}
                          </td>
                          <td *ngIf="daterequesttype.id == 'D'">
                            <input type="radio" formControlName="invoiceType" [value]="daterequesttype.id">
                            {{daterequesttype.text}}
                          </td>
                        </tr>
                  </div>

                  <tr *ngIf='dateRangeChk'>
                    <td> <br>From:
                      <kendo-datepicker formControlName="selectedStartDate"
                                        placeholder="Start Date"

                                        [value]="maxEndDate"
                                        [format]="'yyyy-MM-dd'"
                                        [min]="minEndDate"
                                        [max]="maxEndDate">
                      </kendo-datepicker>

                      To:
                      <kendo-datepicker formControlName="selectedEndDate"
                                        placeholder="End Date"

                                        [value]="maxEndDate"
                                        [format]="'yyyy-MM-dd'"
                                        [min]="minEndDate"
                                        [max]="maxEndDate">
                      </kendo-datepicker>
                    </td>
                  </tr>
          </table>

        </div>
      </tr>

      <tr>
        <td>

          <table class="b-button-bar">
            <tr>
              <td>
                <app-mcl-button text="Next To Parent Selection >" primary="true" (click)="nextClicked()" [disabled]="nextDisabled">
                </app-mcl-button>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

  </form>
</div>

<div kendoDialogContainer></div>




